import React, {useContext} from 'react';
import {observer} from 'mobx-react-lite';
import {StoreContext} from '../base/root-store';
import {
    Button,
    Grid,
    GridColumn,
    Modal,
    ModalCloser,
    ModalContent,
    ModalFooter,
    ModalHeader,
    Toggle,
} from '../../../patterns';

export const QuestionsPageHelpModal = observer((): JSX.Element => {
    const store = useContext(StoreContext).questionStore;
    const content1 = store.label('questions.help-modal.content');
    const sanitizedContent1 = content1.replace(/{'/g, '').replace(/'}/g, '');

    return (
        <Modal size="small">
            <ModalHeader>
                <h4>{store.label('questions.help-modal.title')}</h4>
            </ModalHeader>
            <ModalContent>
                <div className="text">
                    <p dangerouslySetInnerHTML={{__html: sanitizedContent1}}></p>
                    <Grid justify={['right-xs']}>
                        <GridColumn width={['xs-3']} className={'modal__toggle'}>
                            <Toggle id="toggle-1" input={{defaultChecked: false}}/>
                        </GridColumn>
                        <GridColumn width={['xs-9']}>
                            {store.label('questions.help-modal.content-toggle')}
                        </GridColumn>
                    </Grid>
                    <Grid justify={['right-xs']}>
                        <GridColumn width={['xs-3']} className={'modal__toggle'}>
                            <Toggle id="toggle-1" input={{defaultChecked: true}} isPending={true}/>
                        </GridColumn>
                        <GridColumn width={['xs-9']}>
                            {store.label('questions.help-modal.content-toggle.pending')}
                        </GridColumn>
                    </Grid>
                </div>
                <div className="text">
                    <p className="modal__help-link-label">
                        <a href={'https://moticheck.com/kb/'} target={'_blank'} rel="noreferrer">{store.label('common.help-modal.content-help-text-label')}</a>
                    </p>
                </div>
            </ModalContent>
            <ModalFooter>
                <Grid wrap={['xs']} justify={['center-xs']}>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <ModalCloser>
                            <Button block={true} color="white" text={store.label('common.modal.close')}/>
                        </ModalCloser>
                    </GridColumn>
                </Grid>
            </ModalFooter>
        </Modal>
    );
});
